<i18n>
{
  "cl": {
    "currentFeeFalse": "Al día",
    "isForDue": "Cuota disponible",
    "currentFeeTrue": "Por vencer",
    "isDefaulter": "Morosa",
    "isJudicial": "Por comenzar cobranza judicial",
    "of": " de ",
    "quotaNumber": "Cuotas: ",
    "mortgageMonetaryValue": "UF ",
    "complementaryMonetaryValue": "$ ",
    "insolute": "Saldo del crédito:",
    "fireInsurance": "Incendio/Sismo:",
    "lifeInsurance": "Desgravamen:",
    "creditInsurance": "Seguro de crédito:",
    "insurances": "Seguros asociados",
    "mortgage": "Hipotecario",
    "complementary": "Complementario",
    "sme": "PYME",
    "parking": "Pie hipotecario",
    "creditType": "Tipo: ",
    "creditName": "Crédito: ",
    "singleYear": " año",
    "pluralYear": " años",
    "singleMonth": " mes",
    "pluralMonth": " meses",
    "and": " y ",
    "errorMessage": "No hemos podido obtener datos sobre tu crédito",
    "pay-here": "Pagar"
  }
}
</i18n>

<template>
  <div>
    <div class="card-item checkin-content">
      <div v-if="!isLoading" class="progress-bar is-gray">
        <b-progress
          :show-value="true"
          size="is-medium"
          type="is-custom"
          :value="calculateProgress(activeStep,totalSteps)">
          {{ activeStep + 1 }} de {{ totalSteps }}
        </b-progress>
      </div>
      <div id="checkin-welcome" class="card-content">
        <b-steps
          v-model="activeStep"
          :animated="isAnimated"
          :rounded="isRounded"
          :has-navigation="hasNavigation"
          :icon-prev="prevIcon"
          :icon-next="nextIcon"
          :label-position="labelPosition"
          :mobile-mode="mobileMode">
          <b-step-item :clickable="isStepsClickable">
            <Spinner :is-loading="isLoading" />
            <div v-if="!isLoading" class="columns is-desktop is-vcentered">
              <div class="image-check-in column py-0">
                <img src="@/ui/assets/img/questions1.svg" alt="seguridad">
              </div>
              <div class="text-content column is-three-quarters-desktop">
                <h3 class="is-size-5">Bienvenidos a Creditú</h3>
                <p class="is-size-6">
                  En nuestro sitio web y en tu portal privado podrás:
                </p>

                <ul class="is-size-6" style="list-style-type:disc; padding-left: 1.5em">
                  <li>
                    Utilizar <strong>nuestra plataforma de pago</strong>,
                    apenas tu cuota esté disponible.
                  </li>
                  <li>Recibir <strong>nuestros servicios de atención</strong> al cliente.</li>
                  <li v-if="hasDigitalSignatureLink">
                    Ver documentos relacionados a tus créditos.
                  </li>
                </ul>
                <p class="is-size-6" style="margin-top:1em">✨ Todo en un mismo lugar.</p>
              </div>
            </div>
          </b-step-item>

          <!-- Pregunta desaparece si nunca pagó en Andes // ahora desaparece para todos los casos -->
          <!-- <b-step-item
            v-if="user.checkIn.paymentByAndes"
            :clickable="isStepsClickable"
            :type="'is-success'">
            <div class="columns is-desktop is-vcentered">
              <div class="image-check-in column py-0">
                <img src="@/ui/assets/img/question2.svg" alt="seguridad">
              </div>
              <div class="text-content column is-three-quarters-desktop">
                <h3 class="is-size-5">¿Podré volver a pagar por Administradora Andes?</h3>
                <p class="is-size-6">
                  Al realizar tu check-in y <strong>después que confirmemos</strong> que tu información fue actualizada a
                  nuestro sistema Creditú, tus dividendos no podrán ser pagados en Andes.
                </p>
                <p class="is-size-6">
                  Recibirás una notificación con toda la información.
                </p>
              </div>
            </div>
          </b-step-item> -->

          <!-- Pregunta desaparece si es cliente nuevo // ahora desaparece para todos los casos -->
          <!-- <b-step-item
            v-if="user.checkIn.knowAndes"
            :clickable="isStepsClickable"
            :type="'is-success'">
            <div class="columns is-desktop is-vcentered">
              <div class="image-check-in column py-0">
                <img src="@/ui/assets/img/question3.svg" alt="seguridad">
              </div>
              <div class="text-content column is-three-quarters-desktop">
                <h3>¿Qué ocurre si no realizo el check-in?</h3>
                <p>
                  Tu información y dividendos seguirán estando en Andes,
                  deberás pagar por allí tu dividendo y recibirás su atención.<br>
                  Sin embargo, <strong>a partir del 20 de diciembre de 2020</strong>
                  tus dividendos automáticamente serán actualizados
                  al nuevo sistema y <strong>comenzarás a pagar y recibir atención directamente
                    desde tu sitio privado en Creditú.</strong>
                </p>
              </div>
            </div>
          </b-step-item> -->

          <b-step-item :clickable="isStepsClickable" disabled>
            <Spinner :is-loading="isLoading" />
            <div v-if="!isLoading" class="columns is-vcentered is-desktop">
              <div class="image-check-in column py-0">
                <img src="@/ui/assets/img/question4.svg" alt="seguridad">
              </div>
              <div class="text-content column is-three-quarters-desktop">
                <h3 class="is-size-5">¿Cuáles medios de pago tendré disponible en Creditú?</h3>
                <p class="is-size-6">
                  Podrás pagar tu dividendo dentro de tu sitio privado 100% online con los
                  siguientes medios de pago:
                </p>
                <div class="columns is-centered">
                  <div id="payment-method" class="column is-one-quarter-desktop">
                    <div class="payment-icon"><i class="fas fa-university" /></div>
                    <p><span class="payment-label">Transferencia bancaria</span></p>
                  </div>
                  <div id="payment-method" class="column is-one-quarter-desktop">
                    <div class="payment-icon"><i class="fas fa-credit-card" /></div>
                    <p><span class="payment-label">Servipag</span></p>
                  </div>
                  <div id="payment-method" class="column is-one-quarter-desktop">
                    <div class="payment-icon"><i class="fas fa-money-bill-wave" /></div>
                    <p><span class="payment-label">Depósito en efectivo</span></p>
                  </div>
                  <div id="payment-method" class="column is-one-quarter-desktop">
                    <div class="payment-icon">
                      <img alt="neat logo" src="@/ui/assets/img/neat.svg" class="img-gray">
                    </div>
                    <p><span class="payment-label">Neat Pagos</span></p>
                    <p><span class="pay-method-sub font-size">(Tarjeta de crédito)</span></p>
                  </div>
                </div>
              </div>
            </div>
          </b-step-item>
          <!-- Aparece si cliente tiene operaciones PARKING -->
          <b-step-item
            v-if="isParking"
            :clickable="isStepsClickable"
            disabled>
            <div class="columns is-vcentered is-desktop">
              <div class="image-check-in column py-0">
                <img src="@/ui/assets/img/question4.svg" alt="seguridad">
              </div>
              <div class="text-content column is-three-quarters-desktop">
                <h3 class="is-size-5">
                  Aquí te dejamos un resumen de los créditos nuevos que tienes con nosotros.
                </h3>
                <p class="is-size-6">
                  Por favor revisa si la información es correcta antes de continuar.
                </p>
                <p class="is-size-6">
                  Si tienes dudas, puedes hacer click en "Quiero que me contacten" para contactarte con nosotros antes de continuar.
                </p>
              </div>
            </div>
            <div
              v-for="(operation, i) in clientDataResume"
              :key="`operation${i}`"
              class="operation-details is-flex is-flex-direction-column">
              <div
                v-if="operation.creditType === 'PARKING'"
                class="card-item mb-4 py-2 is-flex is-flex-wrap-wrap is-justify-content-space-between is-align-items-center">
                <div>
                  <h3 class="is-size-6 has-text-grey-dark" :icon="iconType[operation.creditType]">
                    {{ $t(operation.creditType?.toLowerCase()) }}
                  </h3>
                  <b-tag
                    icon="hashtag"
                    type="is-primary is-light"
                    class="m-1"
                    rounded>
                    {{ $t('creditName') + operation.companyOperationId }}
                  </b-tag>
                  <b-tag icon="dollar-sign" type="is-primary is-light" class="m-1" rounded>
                    {{ $t('insolute') }} {{
                      operation.creditType === 'MORTGAGE' || operation.creditType === 'PARKING' ?
                        $t('mortgageMonetaryValue') : $t('complementaryMonetaryValue')
                    }} {{ formatter.format(operation.balanceAmmount.toFixed(2)) }}
                  </b-tag>
                  <b-tag
                    icon="hashtag"
                    type="is-primary is-light"
                    class="m-1"
                    rounded>
                    {{ $t('quotaNumber') }} {{ operation.termAsMonths }}
                  </b-tag>
                </div>
                <div class="p-3">
                  <div v-for="(debt, index) in debtDataResume" :key="index">
                    <div v-if="(debt.companyOperationId === operation.companyOperationId)">
                      Monto de la cuota: <strong class="has-text-primary">UF
                        {{ formatter.format(debt.monthlyPayment.toFixed(2)) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-step-item>

          <b-step-item
            v-if="isParking && hasDigitalSignatureLink"
            :clickable="isStepsClickable"
            disabled>
            <div class="columns is-vcentered is-desktop">
              <div class="image-check-in column py-0">
                <img src="@/ui/assets/img/question4.svg" alt="seguridad">
              </div>
              <div class="text-content column is-three-quarters-desktop">
                <h3 class="is-size-5">
                  ¿Tienes aún pendiente la documentación de esta nueva administración?
                </h3>
                <p class="is-size-6">
                  Accede a tu documentación para firmar con Clave Única en solo unos minutos y 100% online, sin papeles y sin salir de tu casa.
                </p>
                <p class="mt-5">
                  <a
                    v-for="(debt, index) in debtDataResume"
                    :key="index"
                    :href="debt.digitalSignatureLink"
                    class="button is-primary is-rounded"
                    target="_blank">
                    <b-icon icon="pen" />
                    <span>Ir a firmar con Clave única</span>
                  </a>
                </p>
              </div>
            </div>
          </b-step-item>
          <template
            v-if="customNavigation"
            slot="navigation"
            slot-scope="{previous, next}">
            <div class="button-navigation-checkin columns is-mobile">
              <div class="column has-text-left">
                <!-- 1/3 Botón si cliente con operaciones Parking -->
                <b-button
                  v-if="isParking"
                  v-show="!previous.disabled"
                  rounded
                  class="is-white step"
                  icon-pack="fas"
                  icon-left="angle-left"
                  @click.prevent="previous.action">
                  Atrás
                </b-button>
                <!-- 2/3 Botón si cliente no tiene operaciones Parking -->
                <b-button
                  v-if="!isParking"
                  v-show="!previous.disabled"
                  class="is-white step"
                  icon-pack="fas"
                  icon-left="angle-left"
                  @click.prevent="previous.action">
                  Atrás
                </b-button>
              </div>
              <div v-if="!isLoading" class="column has-text-right">
                <!-- 1/3 Botón si cliente tiene operaciones parking -->
                <b-button
                  v-if="isParking"
                  v-show="!next.disabled"
                  rounded
                  class="is-white step"
                  icon-pack="fas"
                  icon-right="angle-right"
                  @click.prevent="next.action">
                  Siguiente
                </b-button>
                <!-- 2/3 Botón si cliente no tiene operaciones parking -->
                <b-button
                  v-if="!isParking"
                  v-show="!next.disabled"
                  class="is-white step"
                  icon-pack="fas"
                  icon-right="angle-right"
                  @click.prevent="next.action">
                  Siguiente
                </b-button>
              </div>
            </div>
          </template>
        </b-steps>
      </div>

      <div class="confirmed-term">
        <!--        <div class="button-content left transition-slow">-->
        <!-- 1/3 Botón si cliente ya pagó por andes -->
        <!-- <button
            v-if="user.checkIn.paymentByAndes && user.checkIn.knowAndes"
            v-show="activeStep === 3"
            id="backButton"
            class="button is-button-secondary"
            @click="waitCustom">
            Prefiero esperar
          </button> -->
        <!-- 2/3 Botón si cliente nunca pagó por andes -->
        <!-- <button
            v-if="!user.checkIn.paymentByAndes && user.checkIn.knowAndes"
            v-show="activeStep === 2"
            id="backButton"
            class="button is-button-secondary"
            @click="waitCustom">
            Prefiero esperar
          </button> -->
        <!--        </div>-->
        <div class="button-content transition-slow">
          <!-- 1/3 Botón si cliente tiene operaciones Parking -->
          <button
            v-if="(isParking && (activeStep === 2 || activeStep === 3)) || (isParking && !hasDigitalSignatureLink && activeStep === 3)"
            id="continueButton"
            class="button is-rounded mr-2"
            @click="() => { $router.push({ name: 'support' }); }">
            Quiero que me contacten
          </button>
          <button
            v-if="(isParking && hasDigitalSignatureLink && activeStep === 3)"
            id="continueButton"
            class="button is-button-primary is-rounded"

            @click="()=>{$router.push({ name: 'confirmed' })}">
            Ya firmé
          </button>
          <button
            v-if="(isParking && !hasDigitalSignatureLink && activeStep === 2) || (!isParking && activeStep === 1)"
            id="continueButton"
            class="button is-button-primary is-rounded"

            @click="()=>{$router.push({ name: 'confirmed' })}">
            Continuar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClientDebt, getClientResumeByClientId } from '@/application/services/api-clients/clients';
import Spinner from '@/ui/components/Spinner.vue';

export default {
  components: { Spinner },
  props: { paymentsObject: { type: Object, default: () => ({}) } },

  data() {
    return {
      isLoading: false,
      activeStep: 0,
      isAnimated: true,
      isRounded: true,
      isStepsClickable: false,

      hasNavigation: true,
      customNavigation: true,
      isProfileSuccess: false,

      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      labelPosition: 'bottom',
      mobileMode: 'minimalist',

      clientDataResume: [],

      debtDataResume: [],

      formatter: new Intl.NumberFormat('de-DE'),

      iconType: {
        PARKING: 'fa-solid fa-square-parking',
        MORTGAGE: 'fa-solid fa-house',
        COMPLEMENTARY: 'fa-solid fa-plug-circle-plus',
        SME: 'fa-solid fa-store',
        CONSUME: 'fa-solid fa-bag-shopping',
        HOME_EQUITY: 'fa-solid fa-house-circle-check',
        DOWN_PAYMENT: 'fa-solid fa-hand-holding-dollar'
      }
    };
  },
  computed: {
    user() {
      return this.$store.state.currentUser.user;
    },
    isParking() {
      return this.clientDataResume && Array.isArray(this.clientDataResume) && this.clientDataResume.some(clientDataResume => clientDataResume.creditType === 'PARKING');
    },
    hasDigitalSignatureLink() {
      return this.debtDataResume.some(debtDataResume => debtDataResume.digitalSignatureLink && debtDataResume.digitalSignatureLink !== '');
    },
    totalSteps() {
      let total = 2;
      if (this.isParking && this.hasDigitalSignatureLink) {
        total = 4;
      } else if (this.isParking) {
        total = 3;
      }
      return total;
    }
  },
  async created() {
    try {
      this.isLoading = true;
      const date = this.getNextMonthDate();
      const cancelExecutor = cancelFunction => { this.cancelGetClientDebt = cancelFunction; };
      const debtData = await this.fetchClientDebt(this.user.clientId, date, cancelExecutor);
      this.debtDataResume = this.mapDebtData(debtData);

      this.clientDataResume = await this.fetchClientResumeByClientId(this.user.clientId);
    } catch (_error) {
      this.alert({ message: this.$t('errorMessage') });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    confirmCustom() {
      this.$buefy.dialog.confirm({
        title: '¿Todo listo?',
        message: 'Al confirmar, estarás inscrito para una mejor experiencia en creditu.com',
        cancelText: 'Leer de nuevo...',
        confirmText: 'Confirmar check-in',
        canCancel: true,
        type: 'is-success is-rounded',
        onConfirm: () => this.$router.push({ name: 'confirmed' }),
        onCancel: () => {
          this.activeStep = 0;
        }
      });
    },
    calculateProgress(active, total) {
      return ((active + 1) * 100) / total;
    },
    waitCustom() {
      this.$buefy.dialog.confirm({
        title: '¡No hay problema! ',
        message: `Sin embargo, recuerda que a partir del 20 de diciembre de 2020 tus dividendos
                  serán automáticamente actualizados en creditu.com.
                  Un abrazo virtual.`,
        cancelText: 'Volver',
        confirmText: 'De acuerdo',
        canCancel: true,
        type: 'is-success',
        onConfirm: () => this.$router.push({ name: 'welcome' })
      });
    },
    alert({ message, alertType = 'is-danger' }) {
      this.$buefy.notification.open({
        id: 'alert-type',
        duration: 5000,
        message,
        type: alertType,
        hasIcon: true,
        position: 'is-bottom-left'
      });
    },
    async fetchClientResumeByClientId(clientId, date, cancelExecutor) {
      try {
        return getClientResumeByClientId(clientId, date, cancelExecutor);
      } catch (_error) {
        this.alert({ message: this.$t('errorMessage') });
        this.$log.error(_error);
      }
      return [];
    },
    async fetchClientDebt(clientId, date, cancelExecutor) {
      try {
        return getClientDebt(clientId, date, cancelExecutor);
      } catch (_error) {
        this.alert({ message: this.$t('errorMessage') });
        this.$log.error(_error);
      }
      return [];
    },

    mapDebtData(debtData) {
      try {
        return debtData.debt.map(debtItem => ({
          monthlyPayment: debtItem.payments[0].monthlyPayment,
          companyOperationId: debtItem.companyOperationId,
          digitalSignatureLink: debtItem.digitalSignatureLink,
          test: debtItem.test
        }));
      } catch (_error) {
        this.alert({ message: this.$t('errorMessage') });
        this.$log.error(_error);
      }
      return [];
    },
    getNextMonthDate() {
      const date = new Date();
      date.setMonth(date.getMonth() + 1);
      return date;
    }
  }

};
</script>

<style>
.checkin-content {
  margin: 30px auto 50px;
  padding-bottom: 50px;;
  overflow: inherit;
}

.image-check-in {
  margin: 0px auto;
}

.step-item {
  min-height: 30vh;
}

.checkin-content ul.step-items {
  display: none !important;
}

.text-content, h3 {
  font-size: calc(1vw + 0.2em);
  font-family: var(--secondary-font);
}

.button-content {
  font-size: calc(1vw + 0.2em);
}

.button.step .icon {
  color: var(--primary);
}

.image-check-in {
  width: 13rem;
}

.confirmed-term {
  margin: 30px;
  padding: 5px;
}

.progress-bar {
  padding-top: 40px;
  padding-bottom: 20px;
  max-width: 90%;
  margin: auto;
}

.button-content {
  margin: auto;
}

.confirmed-term {
  display: flex;
}

.modal-card-head {
  background-color: white;
  border-bottom: none;
}

.modal-card-foot {
  background-color: white;
  border-top: none;
}

.button.is-success:focus {
  box-shadow: none !important;
}

.modal-card-foot .button {
  border: 1px solid #00CCD1;
  border-radius: 50rem;
  color: #00CCD1;
}

.button.is-success {
  border: none !important;
  color: white !important;
}

.dialog.has-custom-container {
  position: fixed;
}

#payment-method {
  background: rgb(77 77 77 / 4%);
  margin: 5px;
  text-align: center;
  border-radius: 30px;
  margin-top: 30px;
  margin-bottom: 30px;
  max-width: 150px;
  line-height: 1em;
}

.payment-icon {
  font-size: 30pt;
  height: 65px;
  padding: 5px;
  margin-top: 0px;
}

.payment-icon img {
  max-height: 100%;
  margin-top: 5px;
}

.payment-label {
  font-size: 0.85em;
  line-height: 1pt;
  color: var(--primary);
}

.pay-method-sub {
  font-size: 0.85em;
  line-height: 1pt;
  color: var(--secondary);
}

.mention {
  font-size: 0.7em;
}

.img-gray {
  padding-bottom: 20px !important;
  filter: grayscale(1.5) brightness(0.735);
}

.font-size {
  font-size: 15px;
}

.operation-details .card-item {
  border-radius: 10px;
  border: 1px solid #eaeaea;
}

@media (min-width: 600px) {
  .button-content.left {
    width: 50%;
  }
}

@media (max-width: 1100px) {
  .text-content, h3 {
    font-size: calc(1vw + 0.4em);
    font-family: var(--secondary-font);
  }

  .button.step {
    font-size: calc(1vw + 0.3em);
  }
}

@media (max-width: 768px) {
  .text-content, h3 {
    font-size: calc(1vw + 0.6em);
    font-family: var(--secondary-font);
  }

  .button.step {
    font-size: calc(1vw + 0.5em);
    padding: 10px 30px;
  }

  #payment-method {
    margin-right: auto;
    margin-left: auto;
  }

  .payment-icon {
    height: 85px;
    padding-top: 25px;
    margin-top: 20px;
  }
}

@media (max-width: 600px) {
  h3 {
    font-size: calc(1vw + 0.8em);
  }

  .card-content {
    padding-left: 0px;
    padding-right: 0px;
  }

  .button-content {
    padding: 10px 30px;
    margin: 5px auto;
  }

  .confirmed-term {
    display: grid;
  }
}

@media (max-width: 450px) {
  .button-content {
    padding: 0px;
  }

  .confirmed-term {
    margin: 0px;
  }
}

@media (max-width: 380px) {
  #checkin-welcome {
    padding: 0px;
  }

  .button-navigation-checkin {
    zoom: 0.8;
  }
}

.progress::-webkit-progress-value {
  background-color: #D7D9DB !important;
}

.progress::-moz-progress-bar {
  background-color: #D7D9DB !important;
}

.progress::-ms-fill {
  background-color: #D7D9DB !important;
  border: none;
}

.progress-wrapper .progress-value {
  color: rgba(0, 0, 0, 0.7) !important;
}
</style>
